import React, { useState } from 'react';
import { useAuth } from '../../components/auth/AuthContext';
import { User, Mail, Phone, MapPin, Lock, Save, Camera } from 'lucide-react';
export function Profile() {
  const {
    user
  } = useAuth();
  const [activeTab, setActiveTab] = useState('personal');
  // Mock data for demonstration
  const [formData, setFormData] = useState({
    name: user?.name || '',
    email: user?.email || '',
    phone: '+60 12 345 6789',
    address: '123 Jalan Bukit Bintang, Kuala Lumpur, Malaysia',
    currentPassword: '',
    newPassword: '',
    confirmPassword: ''
  });
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const {
      name,
      value
    } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  const handlePersonalInfoSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // In a real app, this would call an API to update the user's profile
    console.log('Personal info updated:', formData);
    // Show success message
    alert('Profile updated successfully');
  };
  const handlePasswordSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // In a real app, this would call an API to update the user's password
    console.log('Password updated');
    // Reset password fields
    setFormData(prev => ({
      ...prev,
      currentPassword: '',
      newPassword: '',
      confirmPassword: ''
    }));
    // Show success message
    alert('Password updated successfully');
  };
  return <div data-id="element-1114">
      <h1 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-1115">My Profile</h1>
      <div className="bg-white rounded-lg shadow overflow-hidden" data-id="element-1116">
        <div className="border-b border-gray-200" data-id="element-1117">
          <nav className="flex -mb-px" data-id="element-1118">
            <button onClick={() => setActiveTab('personal')} className={`py-4 px-6 text-center border-b-2 font-medium text-sm ${activeTab === 'personal' ? 'border-primary text-primary' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`} data-id="element-1119">
              Personal Information
            </button>
            <button onClick={() => setActiveTab('security')} className={`py-4 px-6 text-center border-b-2 font-medium text-sm ${activeTab === 'security' ? 'border-primary text-primary' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`} data-id="element-1120">
              Security
            </button>
          </nav>
        </div>
        <div className="p-6" data-id="element-1121">
          {activeTab === 'personal' && <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-1122">
              <div className="md:col-span-1" data-id="element-1123">
                <div className="flex flex-col items-center" data-id="element-1124">
                  <div className="relative" data-id="element-1125">
                    <div className="h-32 w-32 rounded-full bg-primary/10 flex items-center justify-center text-primary text-4xl font-medium" data-id="element-1126">
                      {user?.name?.charAt(0).toUpperCase()}
                    </div>
                    <button className="absolute bottom-0 right-0 bg-white rounded-full p-2 shadow-md border border-gray-200 hover:bg-gray-50" data-id="element-1127">
                      <Camera className="h-5 w-5 text-gray-500" data-id="element-1128" />
                    </button>
                  </div>
                  <h3 className="mt-4 text-lg font-medium text-gray-900" data-id="element-1129">
                    {user?.name}
                  </h3>
                  <p className="text-sm text-gray-500" data-id="element-1130">{user?.email}</p>
                  <p className="mt-1 text-sm font-medium text-primary capitalize" data-id="element-1131">
                    {user?.type}
                  </p>
                </div>
              </div>
              <div className="md:col-span-2" data-id="element-1132">
                <form onSubmit={handlePersonalInfoSubmit} data-id="element-1133">
                  <div className="space-y-6" data-id="element-1134">
                    <div data-id="element-1135">
                      <label htmlFor="name" className="block text-sm font-medium text-gray-700" data-id="element-1136">
                        Full Name
                      </label>
                      <div className="mt-1 relative rounded-md shadow-sm" data-id="element-1137">
                        <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-1138">
                          <User className="h-5 w-5 text-gray-400" data-id="element-1139" />
                        </div>
                        <input type="text" name="name" id="name" className="pl-10 block w-full border-gray-300 rounded-md shadow-sm focus:ring-primary focus:border-primary text-gray-900" value={formData.name} onChange={handleChange} data-id="element-1140" />
                      </div>
                    </div>
                    <div data-id="element-1141">
                      <label htmlFor="email" className="block text-sm font-medium text-gray-700" data-id="element-1142">
                        Email Address
                      </label>
                      <div className="mt-1 relative rounded-md shadow-sm" data-id="element-1143">
                        <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-1144">
                          <Mail className="h-5 w-5 text-gray-400" data-id="element-1145" />
                        </div>
                        <input type="email" name="email" id="email" className="pl-10 block w-full border-gray-300 rounded-md shadow-sm focus:ring-primary focus:border-primary text-gray-900" value={formData.email} onChange={handleChange} data-id="element-1146" />
                      </div>
                    </div>
                    <div data-id="element-1147">
                      <label htmlFor="phone" className="block text-sm font-medium text-gray-700" data-id="element-1148">
                        Phone Number
                      </label>
                      <div className="mt-1 relative rounded-md shadow-sm" data-id="element-1149">
                        <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-1150">
                          <Phone className="h-5 w-5 text-gray-400" data-id="element-1151" />
                        </div>
                        <input type="tel" name="phone" id="phone" className="pl-10 block w-full border-gray-300 rounded-md shadow-sm focus:ring-primary focus:border-primary text-gray-900" value={formData.phone} onChange={handleChange} data-id="element-1152" />
                      </div>
                    </div>
                    <div data-id="element-1153">
                      <label htmlFor="address" className="block text-sm font-medium text-gray-700" data-id="element-1154">
                        Address
                      </label>
                      <div className="mt-1 relative rounded-md shadow-sm" data-id="element-1155">
                        <div className="absolute inset-y-0 left-0 pl-3 pt-3 pointer-events-none" data-id="element-1156">
                          <MapPin className="h-5 w-5 text-gray-400" data-id="element-1157" />
                        </div>
                        <textarea name="address" id="address" rows={3} className="pl-10 block w-full border-gray-300 rounded-md shadow-sm focus:ring-primary focus:border-primary text-gray-900" value={formData.address} onChange={handleChange} data-id="element-1158" />
                      </div>
                    </div>
                    <div className="flex justify-end" data-id="element-1159">
                      <button type="submit" className="inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-primary hover:bg-primary/90 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary" data-id="element-1160">
                        <Save className="h-4 w-4 mr-2" data-id="element-1161" />
                        Save Changes
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>}
          {activeTab === 'security' && <div className="max-w-lg mx-auto" data-id="element-1162">
              <form onSubmit={handlePasswordSubmit} data-id="element-1163">
                <div className="space-y-6" data-id="element-1164">
                  <div data-id="element-1165">
                    <label htmlFor="currentPassword" className="block text-sm font-medium text-gray-700" data-id="element-1166">
                      Current Password
                    </label>
                    <div className="mt-1 relative rounded-md shadow-sm" data-id="element-1167">
                      <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-1168">
                        <Lock className="h-5 w-5 text-gray-400" data-id="element-1169" />
                      </div>
                      <input type="password" name="currentPassword" id="currentPassword" className="pl-10 block w-full border-gray-300 rounded-md shadow-sm focus:ring-primary focus:border-primary" value={formData.currentPassword} onChange={handleChange} data-id="element-1170" />
                    </div>
                  </div>
                  <div data-id="element-1171">
                    <label htmlFor="newPassword" className="block text-sm font-medium text-gray-700" data-id="element-1172">
                      New Password
                    </label>
                    <div className="mt-1 relative rounded-md shadow-sm" data-id="element-1173">
                      <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-1174">
                        <Lock className="h-5 w-5 text-gray-400" data-id="element-1175" />
                      </div>
                      <input type="password" name="newPassword" id="newPassword" className="pl-10 block w-full border-gray-300 rounded-md shadow-sm focus:ring-primary focus:border-primary" value={formData.newPassword} onChange={handleChange} data-id="element-1176" />
                    </div>
                    <p className="mt-1 text-sm text-gray-500" data-id="element-1177">
                      Password must be at least 8 characters and include
                      uppercase, lowercase, number and special character.
                    </p>
                  </div>
                  <div data-id="element-1178">
                    <label htmlFor="confirmPassword" className="block text-sm font-medium text-gray-700" data-id="element-1179">
                      Confirm New Password
                    </label>
                    <div className="mt-1 relative rounded-md shadow-sm" data-id="element-1180">
                      <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-1181">
                        <Lock className="h-5 w-5 text-gray-400" data-id="element-1182" />
                      </div>
                      <input type="password" name="confirmPassword" id="confirmPassword" className="pl-10 block w-full border-gray-300 rounded-md shadow-sm focus:ring-primary focus:border-primary" value={formData.confirmPassword} onChange={handleChange} data-id="element-1183" />
                    </div>
                  </div>
                  <div className="flex justify-end" data-id="element-1184">
                    <button type="submit" className="inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-primary hover:bg-primary/90 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary" data-id="element-1185">
                      <Save className="h-4 w-4 mr-2" data-id="element-1186" />
                      Update Password
                    </button>
                  </div>
                </div>
              </form>
            </div>}
        </div>
      </div>
    </div>;
}